var chunkToChildrenMap = {
	"8406": [
		794,
		3845,
		2831,
		1174,
		7451,
		1210,
		7114,
		6031,
		2684,
		8225
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));